import { render, staticRenderFns } from "./EditSalesPaymentPage.vue?vue&type=template&id=64afc5ac"
import script from "./EditSalesPaymentPage.vue?vue&type=script&lang=js"
export * from "./EditSalesPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports